import HazardDropDown from './Index.vue'

HazardDropDown.install = function(Vue) {
    Vue.component(HazardDropDown.name, HazardDropDown)
}

export default HazardDropDown
